export default "__VITE_ASSET__80fe43e4__"